import DownloadSVG from '@public/icons/download.svg';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Document } from '@/entities/document';
import { isPdf } from '@/shared/hooks/use-form-sender/validator/utils';
import { tp } from '@/shared/lib/typograf';
import { getDocumentIconComponentByUrl } from '@/shared/lib/utils/get-document-icon-component-by-url';

export type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    document: Document;
};

const DocumentLink = forwardRef<HTMLAnchorElement, Props>(({ document, ...props }, ref) => {
    const DocIconComponent = getDocumentIconComponentByUrl(document.src);

    return (
        <a
            {...props}
            ref={ref}
            target={isPdf(document.src) ? '_blank' : undefined}
            rel={isPdf(document.src) ? 'noreferrer' : undefined}
            download={isPdf(document.src) ? undefined : true}
            href={document.src}
            className={classNames('participation-presentation-btn', props.className)}
        >
            <span className="presentation-btn-left">
                {DocIconComponent && <DocIconComponent />}
                <span
                    className="text-xs"
                    dangerouslySetInnerHTML={{ __html: tp(document.title || 'Скачать документ') }}
                ></span>
            </span>
            <DownloadSVG className="download-svg" />
        </a>
    );
});

DocumentLink.displayName = 'DocumentLink';

export default DocumentLink;
